<!--  -->
<template>
  <div
    class="organization-child"
    element-loading-text="数据加载中"
    v-if="treeVisible"
    v-loading="loading"
  >
    <el-scrollbar style="height: 100%;">
      <el-tree
        :props="props"
        :load="loadNode"
        lazy
        ref="orgTree"
        show-checkbox
        :check-strictly="true"
        :expand-on-click-node="false"
        :highlight-current="false"
        @check="checkNode"
      >
        <template #default="{ node, data }">
          <ul class="organization-child-content">
            <span class="line" v-if="data.parent"></span>
            <!-- 组织名称 -->
            <li>
              <el-tooltip class="item" effect="dark" :content="data.name" placement="top">
                <span>{{ dealShowName(data) }}</span>
              </el-tooltip>
            </li>
            <!-- 是否流程显示 -->
            <li>
              <el-switch v-model="data.uservisible" :active-value="1" :inactive-value="0" @change="upProcess($event, data)"></el-switch>
            </li>
            <!-- 组织类型 -->
            <li>  
              <span v-if="dealType(data.type)"
                    :style="{ color: labelView({val: data.type, type: 'color'}), backgroundColor: labelView({val: data.type, type: 'background'}) }">
                {{ dealType(data.type) }}
              </span>
              <span class="none-type" v-else>无类型</span>
            </li>
            <!-- 组织管理员-->
            <li>{{ dealAdmintor(data.admintor)}}</li>
            <!-- 主管 -->
            <li>{{ dealMuser(data.muser) }}</li>
            <!-- 排序 -->
            <li @dblclick="upSort(data)">
              <el-input v-if="upOrganizationId && upOrganizationId === data.organizationId" type="number" v-model="orgId" size="mini" class="sort-input" :ref="'id' + data.organizationId" @click.stop @blur="upSortFun(data)" @input="upOrgId" />
              <template v-else>
                {{ data.orders }}
              </template>
            </li>
            <!-- 是否激活 -->
            <li>
              <span :class="data.status == '1' ? 'activate' : 'disactivate'">{{ numTStr(data.status) }}</span>
            </li>
            <!-- 操作 -->
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="创建下级组织"
                placement="bottom-end"
              >
                <i
                  class="WSiconfont WSicon-add"
                  @click="$emit('del-edit', data, 0, node)"
                ></i>
              </el-tooltip>
              <div class="todo-center"></div>
              <el-tooltip
                class="item"
                effect="dark"
                content="编辑"
                placement="bottom-end"
              >
                <i
                  class="WSiconfont WSicon-a-EditSquare1"
                  @click="$emit('del-edit', data, 1, node)"
                ></i>
              </el-tooltip>
              <div class="todo-center"></div>
              <el-tooltip
                class="item"
                effect="dark"
                content="删除"
                placement="bottom-end"
              >
                <i
                  class="WSiconfont WSicon-shanchu"
                  @click="$emit('del-edit', data, 2, node)"
                ></i>
              </el-tooltip>
              <div class="todo-center"></div>
              <!-- 更多设置 -->
              <el-popover
                placement="bottom"
                popper-class="more-operate"
                width="100"
                trigger="hover">
                <template  v-if="data.type !== 8 && data.type !== ''">
                  <p v-if="data.type < 4 || data.type === 9"
                      @click="onClickOrganization(1, 1, data)">批量创建</p>
                  <p v-if="data.type !== -1"
                      @click="onClickOrganization(3, 2, data)">批量导入管理员</p>
                  <p v-if="data.type > 3 && data.type < 7"
                      @click="onClickOrganization(1, '', data)">快速创建</p>
                  <p v-if="data.type === 4 || data.type === 5"
                      @click="onClickOrganization(3, 4, data)">创建行政部门</p>
                  <template v-if="data.type === 7">
                    <p @click="onClickOrganization(1, '', data)">创建行政班</p>
                    <p @click="onClickOrganization(3, 3, data)">创建自定义班级</p>
                  </template>
                </template>
                <template #reference>
                  <i class="iconfont icon-gengduo2" />
                </template>
              </el-popover>
            </li>
          </ul>
        </template>
      </el-tree>
    </el-scrollbar>
    <!-- 批量添加(童) -->
    <batch-create
      v-model:batch="batchShow"
      v-model:datas="batchDatas"
      :type="batchDatasType"
      @batchClose="batchClose"
    />
    <!-- 批量添加学校部门(大刘) -->
    <pikaluonti
      ref="pikaluontiRefs"
      :datas="pikaluontiDatas"
      v-if="pikaluontiShow"
      @closePikaluonti="closePikaluonti"
    />
  </div>
</template>

<script>
import treeMixins from './common/common.js'
import treeMinix from './mixins/tree.js' // 中台协同网络的操作
import { getdepttiplist } from '@/port/admins/organizationUser'
import { typeObj } from '@/util/constants.js'
import { updateorgorders } from '@/port/admins/organizationSpace'
import { updateorganization } from '@/port/admins/organizationSpace.js'
import { getOrgShowName } from "@/api/global.js";
export default {
  components: {
    // managementMode: ()=>import('./managementMode/index')
  },
  data () {
    return {
      props: {
        children: "children",
        label: "label",
        isLeaf: "isLeaf"
      },
      treeVisible: true,
      organizationType: [],
      checkList: {
        idArr: [],
        dataList: []
      }, // 选中的节点
      upOrganizationId: '',
      orgId: ''
    };
  },
  mixins: [treeMixins, treeMinix],
  props: {
  },
  computed: {
    
  },
  mounted () {
    this.getOrganizationType()
  },
  methods: {
    numTStr (val) {
      let str = '未激活';
      if (val == '1') {
        str = '已激活';
      }
      return str;
    },
    dealShowName(data){
      return getOrgShowName(data)
    },
    async upProcess (val, item) {
      console.log('upProcess', val, item)
      const obj = {
        organizationId: item.organizationId,
        uservisible: val
      }
      const res = await updateorganization(obj).catch(err => { console.log(err) })
      console.log('修改结果', res)
      if (res.code === 0) {
        // TODO
      } else {
        this.$message.error(res.msg || '修改失败')
      }
    },
    upOrgId (val) {
      if (val < 0) {
        this.$message.warning('排序不能小于0！！')
        this.orgId = 0
      }
    },
    async upSort (data) {
      this.orgId = data.orders
      this.upOrganizationId = data.organizationId
      await this.$nextTick()
      setTimeout(() => {
        this.$refs['id' + data.organizationId].focus()
      }, 10)
    },
    async upSortFun (data) {
      const ob = { organizationId: data.organizationId, orders: this.orgId || 0 }
      const { code, msg } = await updateorgorders(ob).catch(err => { console.log(err) })
      if (code === 0) {
        this.$message.success(msg || '修改成功！')
        this.refreshTree()
        this.upOrganizationId = ''
        this.orgId = ''
      } else {
        this.$message.error(msg || '修改失败!')
      }
    },
    // 节点刷新
    nodeRefresh (node) {
      if (node && node.parent) {
        node.parent.loaded = false // 设置loaded为false；模拟一次节点展开事件，加载重命名后的新数据；
        node.parent.expand()
      }
    },
    // 数据刷新
    refreshTree(){
      this.treeVisible = false
      this.$nextTick(()=>{
        this.treeVisible = true
      })
      this.checkList = {
        idArr: [],
        dataList: [],
      }
    },
    // 获取组织类型
    async getOrganizationType () {
      const { data, code, msg } = await getdepttiplist({
        curpage: 1,
        pagesize: 9999
      })
      if (code === 0) {
        this.organizationType = data
      } else {
        this.$message.error(msg)
      }
    },
    // 选择节点
    checkNode(node) {
      const index = this.checkList.idArr.indexOf(node.organizationId)
      if(index === -1) {
        this.checkList.idArr.push(node.organizationId)
        this.checkList.dataList.push(node)
      } else {
        this.checkList.idArr.splice(index, 1)
        this.checkList.dataList.splice(index, 1)
      }
      console.log(this.checkList)
      this.$emit('check', this.checkList)
    },
    // 组织类型色卡
    labelView ({ val, type }) {
      const itype = this.organizationType.find(item => item.deptTipId === val) || {}
      if (itype.deptTipId > 9) {
        return typeObj[itype.colours] && typeObj[itype.colours][type]
      } else {
        return typeObj[itype.deptTipId] && typeObj[itype.deptTipId][type]
      }
    },
    dealType (type) {
      const itype = this.organizationType.find(item => item.deptTipId === type) || {}
      return itype.name
    },
    // 组织管理员
    dealAdmintor(value) {
      let admintor = '暂无'
      if(value && JSON.parse(value).length > 0) {
        admintor = JSON.parse(value).map(x=>x.name || x.realname).join('、')
      }
      return admintor
    },
    // 主管
    dealMuser (value) {
      let muser = '暂无'
      if (typeof value === 'string') {
        const muserArr = JSON.parse(value)
        if (muserArr.length === 0) {
          muser = '暂无'
        } else if (muserArr.length <= 2) {
          const arr = muserArr.map(item => item.realname || item.name)
          muser = arr.join(',')
        } else {
          const count = muserArr.length
          const arr = muserArr.splice(0, 2).map(item => item.realname || item.name)
          muser = `${arr.join(',')}等${count}人`
        }
      }
      return muser
    }
  },
  watch: {},
}
</script>
<style lang='scss' scoped>
@import "./css/common.scss";
.sort-input {
  width: 60px;
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.organization-child {
  width: 100%;
  height: 100%;

  ::v-deep .el-tree {
    .el-tree-node {
      &:nth-of-type(2n) {
        background-color: $table-bg-grey-1;
      }
      .el-tree-node__content {
        height: 40px;
        line-height: 40px;
      }
    }
  }
  &-content {
    flex: 1;
    display: flex;
    height: 40px;
    line-height: 40px;
    position: relative;
    .line{
      position: absolute;
      display: block;
      left: -54px;
      bottom: 20px;
      width: 13px;
      height: 500px;
      border-left: 1px solid #DDEDFB;
      border-bottom: 1px solid #DDEDFB;
    }
    li {
      text-align: center;
      &:nth-of-type(1) {
        text-align: left;
        flex: 1;
      }
      &:nth-of-type(2) {
        width: 140px;
      }
      &:nth-of-type(3) {
        width: 140px;
        span {
          border-radius: 4px;
          background: rgba(255, 139, 10, 0.1);
          padding: 6px 16px;
          color: #ff8b0a;
          font-size: $text-size-mi;
          font-weight: $text-weight-sm;
          font-family: $text-family;
        }
        .none-type {
          background-color: rgba(225,230,235,0.5);
          color: #adb0b2;
          margin-left: 8px;
        }
      }
      &:nth-of-type(4) {
        width: 140px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &:nth-of-type(5) {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 102px;
      }
      &:nth-of-type(6) {
        width: 93px;
      }
      &:nth-of-type(7) {
        width: 132px;
        span {
          padding: 6px 16px;
          font-size: $text-size-mi;
          font-weight: $text-weight-sm;
          font-family: $text-family;
          border-radius: 16px;
        }
        .activate {
          background: rgba(6, 212, 125, 0.1);
          color: #06d47d;
        }
        .disactivate {
          background: rgba(225, 230, 235, 0.5);
          color: #adb0b2;
        }
      }
      &:nth-of-type(8) {
        width: 200px;
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        .todo-center {
          width: 1px;
          background: #ebe8e1;
          margin: 4px;
          height: 10px;
        }
        .WSiconfont, .iconfont {
          font-size: $text-size-sm;
        }
        .WSicon-add, .WSicon-a-EditSquare1 {
          color: $color-main;
        }
        .WSicon-shanchu {
          color: $color-error;
        }
        
      }
    }
  }
}
</style>
<style>
.el-popover.more-operate{
  padding: 4px 0 4px 0 !important;
}
.el-popover.more-operate p{
  padding: 4px;
  cursor: pointer;
  text-align: center;
  font-size: 12px;
}
.el-popover.more-operate p:hover{
  background-color: #f1f8ff;
}
</style>